module.exports = __webpack_public_path__ + "e785ca35b86847035d74896276f4852d.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1081
// module chunks = 0